import moment from 'moment';
import { hasCurrentValue } from './summaryRows';

// `source` of the PATCH: the changelog tells imported values apart (REQ-21).
export const FILE_IMPORT_SOURCE = 'fileImport';

// Start of the day in UTC, as the value insertion form writes dates.
const utcDay = (date) => moment.utc(date).startOf('day').toDate();

// Only what the import writes: any other field of the value stays as it is.
export function writeBody(row, { dateStart, dateEnd }) {
  return {
    value: row.value,
    LD: row.LD,
    analysisStart: utcDay(dateStart),
    analysisEnd: utcDay(dateEnd),
    measureId: row.measureId,
  };
}

// `outcomes` by row index: null once written, the error message otherwise;
// rows not written yet have none.
export function writeCounts(rows, outcomes) {
  const written = Object.keys(outcomes).filter((key) => outcomes[key] === null);
  return {
    written: written.length,
    overwritten: written.filter((key) => hasCurrentValue(rows[key])).length,
    failed: Object.keys(outcomes).length - written.length,
  };
}

// Calls before the pace says something about the rest.
export const ESTIMATE_MIN_CALLS = 3;

// Milliseconds left at the pace so far; null while too early to tell.
export function remainingMs(elapsedMs, done, total) {
  if (done < ESTIMATE_MIN_CALLS || done >= total) return null;
  return (elapsedMs / done) * (total - done);
}
